import React, { ReactNode } from 'react'
import { makeStyles } from '@mui/styles'
import { useSignatureContext } from '@/modules/signature/_helpers/SignatureContext'
import SignaturePositionMarker from '@/modules/signature/components/overlay/signature-position-marker'
import DateFieldPositionMarker from '@/modules/signature/components/overlay/date-field-position-marker'
import TextFieldPositionMarker from '@/modules/signature/components/overlay/text-field-position-marker'
import { SIGNATURE_FIELD_TYPES } from '@/modules/base/util/constants'

type SignaturePositionOverlayProps = {
  children?: ReactNode,
  scale?: number,
}

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
    display: 'inline-flex',
    userSelect: 'none',
  },
}), { name: 'SignaturePositionOverlay' })

const SignaturePositionOverlay = (props: SignaturePositionOverlayProps) => {
  const { children } = props
  const styles = useStyles()
  const { items, currentItemIndex } = useSignatureContext()

  return (
    <div className={styles.container}>
      {children}
      {items.length > 0 && items.map((item, index) => {
        switch (item.type) {
          case SIGNATURE_FIELD_TYPES.DATE: {
            return (
              <DateFieldPositionMarker
                key={index}
                i={index}
                dateField={item}
                active={currentItemIndex === index} />
            )
          }
          case SIGNATURE_FIELD_TYPES.TEXT: {
            return (
              <TextFieldPositionMarker
                key={index}
                i={index}
                textField={item}
                active={currentItemIndex === index} />
            )
          }
          default: {
            return (
              <SignaturePositionMarker
                key={index}
                i={index}
                signature={item}
                active={currentItemIndex === index} />
            )
          }
        }
      })}
    </div>
  )
}

export default SignaturePositionOverlay
